"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var dataPointToRenderPoint_1 = __importDefault(require("../core/common/dataPointToRenderPoint"));
var interpolateRenderPoints_1 = __importDefault(require("../core/common/interpolateRenderPoints"));
var translateXy_1 = __importDefault(require("../core/common/translateXy"));
var ChartWeb_1 = require("./ChartWeb");
var chartWithPopup = function (props) {
    if (!global.window)
        return null;
    var _a = React.useState(props.config), config = _a[0], setConfig = _a[1];
    var _b = React.useState(), viewBox = _b[0], setViewBox = _b[1];
    var _c = React.useState([]), chartXys = _c[0], setChartXys = _c[1];
    var _d = React.useState([0, 0]), cursorXY = _d[0], setCursorXY = _d[1];
    var _e = React.useState([0, 0]), pointer = _e[0], setPointer = _e[1];
    var _f = React.useState(-1), currentX = _f[0], setCurrentX = _f[1];
    var _g = React.useState([]), interpolatedRenderPoints = _g[0], setInterpolatedRenderPoints = _g[1];
    var mousePadRef = React.useRef(null);
    var onPointerMove = function (e) {
        setPointer([e.offsetX, e.offsetY]);
    };
    var onMouseOut = function (e) {
        if (!e.currentTarget)
            return;
        props.onSelected(-1, -1, 0, 0);
    };
    var clearMousePadEventListener = function (mousePadElm) { return function () {
        if (!mousePadElm)
            return;
        mousePadElm.removeEventListener('pointermove', onPointerMove);
        mousePadElm.removeEventListener('mouseout', onMouseOut);
    }; };
    var initMousePad = function (mousePadElm, config) {
        clearMousePadEventListener(mousePadElm);
        mousePadElm.addEventListener('pointermove', onPointerMove);
        mousePadElm.addEventListener('mouseout', onMouseOut);
    };
    var onRendered = function (dataPointGroups, _viewBox, _chartXys) {
        setViewBox(_viewBox);
        setChartXys(_chartXys);
        var renderPoints = dataPointToRenderPoint_1.default(props.config.charts, dataPointGroups);
        var _interpolatedRenderPoints = interpolateRenderPoints_1.default(renderPoints, mousePadRef.current, _viewBox, _chartXys);
        if (_interpolatedRenderPoints) {
            setInterpolatedRenderPoints(_interpolatedRenderPoints);
        }
    };
    var onXyIndexesChanged = function (xyIndex, _, __, chartIdx) {
        if (chartIdx === void 0) { chartIdx = 0; }
        var point = [0, 0];
        if (interpolatedRenderPoints.length > 0) {
            point = interpolatedRenderPoints[chartIdx].values[xyIndex.indexY].points[xyIndex.indexX].dest;
        }
        if (props.config.charts[chartIdx].yAxis.ignoreZeroPoint && props.config.charts[chartIdx].values[xyIndex.indexY].series[xyIndex.indexX] === 0) {
            point = [0, 0];
        }
        setCurrentX(xyIndex.indexX);
        props.onSelected(xyIndex.indexX, xyIndex.indexY, point[0], point[1]);
    };
    React.useEffect(function () {
        if (props.config) {
            var newConfig = __assign(__assign({}, props.config), { charts: props.config.charts.map(function (it) { return (__assign(__assign({}, it), { selectedIndex: currentX })); }) });
            setConfig(newConfig);
        }
    }, [props.config]);
    React.useEffect(function () {
        if (!pointer[0] || !pointer[1] || !viewBox || !chartXys.length)
            return;
        var xy = translateXy_1.default.fromBrowser(pointer[0], pointer[1], mousePadRef.current, viewBox, chartXys)[0];
        setCursorXY(xy);
    }, [pointer, viewBox, chartXys]);
    React.useEffect(function () {
        var newConfig = __assign(__assign({}, config), { charts: config.charts.map(function (it) { return (__assign(__assign({}, it), { selectedIndex: currentX })); }) });
        setConfig(newConfig);
    }, [currentX]);
    React.useEffect(function () {
        if (!config)
            return;
        initMousePad(mousePadRef.current, config);
        return function () {
            clearMousePadEventListener(mousePadRef.current);
        };
    }, []);
    return (React.createElement("div", { className: "u-okaychart-container", style: { position: 'relative' } },
        React.createElement("div", { style: { position: 'absolute', width: '100%', height: '100%', top: 0, zIndex: 1 }, className: "u-okaychart-mousepad", ref: mousePadRef }),
        React.createElement("div", { className: "u-okaychart-svg" },
            React.createElement(ChartWeb_1.ChartWeb, { config: config, cursorXy: cursorXY, onXyIndexesChanged: onXyIndexesChanged, onRendered: onRendered }))));
};
exports.default = chartWithPopup;
